var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"right":"-15px"},attrs:{"absolute":"","top":"","fab":"","x-small":"","color":"grey lighten-4","dark":""},on:{"click":_vm.emitOnClick}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v(" mdi-trash-can-outline ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }